//服务收费详情
<template>
  <div>
    <el-descriptions title="服务收费单申请" border :colon="false">
      <el-descriptions-item label="申请单号：">
        {{ orderResult.orderCode }}
      </el-descriptions-item>
      <el-descriptions-item label="U8销售单号：">
        {{ orderResult.u8SellCode }}
      </el-descriptions-item>
      <el-descriptions-item label="U8发货单号：">
        {{ orderResult.u8DeliveryCode }}
      </el-descriptions-item>
      <el-descriptions-item label="订单日期：">
        {{ orderResult.orderTime | date('YYYY-mm-dd') }}
      </el-descriptions-item>
      <el-descriptions-item label="关联工单号：">
        {{ orderResult.workOrderCode || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="销售类型：">
        {{ sellTypeStr }}
      </el-descriptions-item>
      <!-- <el-descriptions-item label="业务类型：">
        {{ businessTypeStr }}
      </el-descriptions-item> -->
      <el-descriptions-item label="销售部门：">
        {{ orderResult.salesDepartmentName }}
      </el-descriptions-item>
      <el-descriptions-item label="所属区域：">
        {{
          orderResult.provinceName +
          '-' +
          orderResult.cityName +
          '-' +
          orderResult.areaName
        }}
      </el-descriptions-item>
      <el-descriptions-item label="业务员：">
        {{ orderResult.salesmanName }}
      </el-descriptions-item>
      <el-descriptions-item label="上门安装：">
        {{ orderResult.installType == 1 ? '是' : '否' }}
      </el-descriptions-item>
      <el-descriptions-item label="保修方式：">
        {{ maintenanceTypeStr }}
      </el-descriptions-item>
      <el-descriptions-item label="客户名称：">
        {{ orderResult.clientName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="付款方式：">
        {{ payWayStr }}
      </el-descriptions-item>
      <el-descriptions-item label="要求发货日期：">
        {{ orderResult.requireDeliverTime | date('YYYY-mm-dd') }}
      </el-descriptions-item>
      <el-descriptions-item label="联系人：">
        {{ orderResult.linkman || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="联系人手机：">
        {{ orderResult.linkmanPhone || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="联系人地址：">
        {{ orderResult.linkmanAddress || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="备注：">
        {{ orderResult.remark || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="附件：">
        <div>
          <FileList v-if="orderResult.attachmentUrl" :attachmentUrl="orderResult.attachmentUrl" />
          <div v-else>-</div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="工厂维修：">
        {{ orderResult.send == 1 ? '是' : '否' }}
      </el-descriptions-item>
      <el-descriptions-item label="是否确认维修：" v-if="orderResult.send == 1">
        {{ orderResult.repair == 1 ? '是' : '否' }}
      </el-descriptions-item>
      <el-descriptions-item label="物流信息：" v-if="orderResult.send == 1">
        {{ orderResult.logistics || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="维修设备料号：" v-if="orderResult.send == 1">
        {{ orderResult.code || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="维修设备名称：" v-if="orderResult.send == 1">
        {{ orderResult.name || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="维修设备SN：" v-if="orderResult.send == 1">
        {{ orderResult.sn || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="故障原因：" v-if="orderResult.send == 1">
        {{ orderResult.detail || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="工厂寄送配件：" v-if="orderResult.send == 0">
        {{ orderResult.accessories == 1 ? '是' : '否' }}
      </el-descriptions-item>
      <el-descriptions-item label="维修凭证：" v-if="orderResult.send == 1">
        <div>
          <ImageList v-if="orderResult.repairUrl" :attachmentUrl="orderResult.repairUrl" />
          <div v-else>-</div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="收费凭证：">
        <div>
          <ImageList v-if="orderResult.payUrl" :attachmentUrl="orderResult.payUrl" />
          <div v-else>-</div>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <el-divider content-position="left">
      维修清单
      <el-button size="mini" type="primary" @click="downalod" style="padding: 3px 5px; margin-left: 10px">
        下载维修清单
      </el-button>
    </el-divider>
    <el-table :data="detailResults" :span-method="objectSpanMethod">
      <el-table-column align="center" label="序号" type="index" width="60" />
      <el-table-column label="故障原因" prop="reason">
        <template slot-scope="{ row }">
          {{ row.reason || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="维修项" prop="maintenance">
        <template slot-scope="{ row }">
          {{ row.maintenance || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="code" label="料号" />
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="sn" label="SN"
        v-if="orderResult.send === 0 && orderResult.accessories === 0" />
      <el-table-column header-align="center" align="center" label="单价">
        <template slot-scope="{ row }">
          {{ (row.price / 100) | dividedInto }}
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="数量">
        <template slot-scope="{ row }">
          {{ row.num | dividedInto }}
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="库存数量">
        <template slot-scope="{ row }">
          {{ row.totalNum | dividedInto }}
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="小计费用">
        <template slot-scope="{ row }">
          {{ (row.totalAmount / 100) | dividedInto }}
        </template>
      </el-table-column>
      <el-table-column label="仓库">
        <template slot-scope="{ row }">
          {{ row.warehouseName || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="货位">
        <template slot-scope="{ row }">
          {{ row.storageName || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="备注">
        <template slot-scope="{ row }">
          {{ row.remark || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="最后更新人">
        <template slot-scope="{ row }">
          {{ row.updateNickname || '-' }}
        </template>
      </el-table-column>
    </el-table>
    <el-descriptions title=" " border :colon="false">
      <el-descriptions-item label="费用合计：">
        {{ priceTotal }}
      </el-descriptions-item>
      <el-descriptions-item label="有无特价：">
        {{ orderResult.specialAmount ? '有' : '无' }}
      </el-descriptions-item>
      <template v-if="orderResult.specialAmount">
        <el-descriptions-item label="特价单号：">
          {{ orderResult.specialOrderCode || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="特价后价格：">
          {{ (orderResult.specialAmount / 100) | dividedInto }}
        </el-descriptions-item>
      </template>
    </el-descriptions>
  </div>
</template>

<script>
import detailMixins from './detailMixins.js'
export default {
  mixins: [detailMixins],
  computed: {
    sellTypeStr() {
      let sellType = this.orderResult.sellType
      let name =
        this.$constant.sellType.find(a => a.value === sellType)?.label || ''
      return name
    },
    businessTypeStr() {
      let businessType = this.orderResult.businessType
      let name =
        this.$constant.businessType.find(a => a.value === businessType)
          ?.label || ''
      return name
    },
    maintenanceTypeStr() {
      let maintenanceType = this.orderResult.maintenanceType
      let name =
        this.$constant.maintenanceType.find(a => a.value === maintenanceType)
          ?.label || ''
      return name
    },
    payWayStr() {
      let payWay = this.orderResult.payWay
      let name =
        this.$constant.payWay.find(a => a.value === payWay)?.label || ''
      return name
    },
    priceTotal() {
      let list = this.detailResults || []
      let sum = 0
      list.forEach(a => {
        sum += a.price * a.num
      })
      return sum / 100
    },
    // 维修项列合并：相同 maintenance 连续行的 rowspan 数组，0 表示该格被合并隐藏
    maintenanceSpanArr() {
      const list = this.detailResults || []
      const arr = []
      let i = 0
      while (i < list.length) {
        let count = 1
        const val = list[i].maintenance
        while (i + count < list.length && (list[i + count].maintenance || '') === (val || '')) {
          count += 1
        }
        arr.push(count)
        for (let j = 1; j < count; j++) arr.push(0)
        i += count
      }
      return arr
    }
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'maintenance' || column.property === 'reason') {
        const span = this.maintenanceSpanArr[rowIndex]
        return { rowspan: span, colspan: 1 }
      }
      return { rowspan: 1, colspan: 1 }
    },
    downalod() {
      this.$emit('export')
    }
  }
}
</script>
